import firebase from 'firebase/app';
import 'firebase/analytics';

export const initAnalytics = (app) => firebase.analytics(app);

export const logEvent = (event, attributes) => {
  firebase.analytics().logEvent(event, attributes);
};
